/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class CertExamApply extends Ce {
    constructor() {
        super();
        this.baseUrl += '/examineeAdmitCard';
    }

    printData({ idCardNo }) {
        return super.get('/printData', { idCardNo });
    }
}

export default new CertExamApply();
export { CertExamApply };
